// extracted by mini-css-extract-plugin
module.exports = {"match-header-scores":"match-header-scores","team-item":"team-item","scores-info":"scores-info","status":"status","score":"score","team-text":"team-text"};